import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    // Modo claro/escuro
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem('sv-theme');
        return saved || 'dark';
    });
    
    // Layout: classic ou minimal
    const [layoutMode, setLayoutMode] = useState(() => {
        const saved = localStorage.getItem('sv-layout-mode');
        return saved || 'classic';
    });

    useEffect(() => {
        localStorage.setItem('sv-theme', theme);
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(theme);
    }, [theme]);
    
    useEffect(() => {
        localStorage.setItem('sv-layout-mode', layoutMode);
        document.documentElement.classList.remove('layout-classic', 'layout-minimal');
        document.documentElement.classList.add(`layout-${layoutMode}`);
    }, [layoutMode]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'dark' ? 'light' : 'dark');
    };
    
    const toggleLayoutMode = () => {
        setLayoutMode(prev => prev === 'classic' ? 'minimal' : 'classic');
    };

    const value = {
        theme,
        setTheme,
        toggleTheme,
        isDark: theme === 'dark',
        layoutMode,
        setLayoutMode,
        toggleLayoutMode,
        isClassic: layoutMode === 'classic'
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
